import React, { useContext } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'
import { MemberSummary } from '@Entities/member/member-summary'
import useRightsholderReset from '@App/services/useRightsholderReset'

const RightsholderTray = () => {
    const { popupStore, rightsholderStore, rightsholderSearchStore } = useContext(StoresContext)
    const resetRightsholder = useRightsholderReset()
    const allDoneRightsHolders = rightsholderSearchStore.rightsholders

    return (
        <div className="rightsholders-tray-component">
            <div className="rightsholders-tray-list">
                {allDoneRightsHolders &&
                    allDoneRightsHolders.content.map((item: MemberSummary) => {
                        const isCurrentRightsholder = rightsholderStore.optionalCurrentRightsholderId === item.ipId
                        const divClassNames = clsx('rightsholders-card', isCurrentRightsholder && 'current')
                        return (
                            <NavLink
                                to={Navigation.rightholder.summary(item.ipId)}
                                key={item.ipId}
                                onClick={() => {
                                    if (!isCurrentRightsholder) {
                                        resetRightsholder()
                                    }
                                    popupStore.setRightsholderTrayState(false)
                                }}
                            >
                                <div className={divClassNames} key={item.ipId}>
                                    <img src={ICONS.account} alt="Accounts" />
                                    <div className="name-block">
                                        <p className="small bold" title={item.name}>
                                            {item.name}
                                        </p>
                                    </div>
                                </div>
                            </NavLink>
                        )
                    })}
            </div>
            <div className="closer" onMouseDown={() => popupStore.setRightsholderTrayState(false)} />
        </div>
    )
}

export default observer(RightsholderTray)
